import { useSelector } from "react-redux";


export function AvgWorkoutsCard() {
    const userInsights = useSelector((store) => store.UserInsights.userInsights);
    return (
        <div className="avg-workouts-card">
            <div className="avg-label-value-container">
                <div className="avg-workout-value">
                    {userInsights?.numberOfWorkoutsPerWeek?.[0]?.last30days ?? 0}
                </div>
                <div className="avg-workout-label">
                    Last 30 days
                </div>
            </div>


            <div className="avg-label-value-container">
                <div className="avg-workout-value">
                    {userInsights?.numberOfWorkoutsPerWeek?.[0]?.last60days ?? 0}
                </div>
                <div className="avg-workout-label">
                    Last 60 days
                </div>
            </div>


            <div className="avg-label-value-container">
                <div className="avg-workout-value">
                    {userInsights?.numberOfWorkoutsPerWeek?.[0]?.last90days ?? 0}
                </div>
                <div className="avg-workout-label">
                    Last 90 days
                </div>
            </div>

            <div className="avg-label-value-container">
                <div className="avg-workout-value">
                    {userInsights?.numberOfWorkoutsPerWeek?.[0]?.last365days ?? 0}
                </div>
                <div className="avg-workout-label">
                    Last 365 days
                </div>
            </div>

        </div>
    );
}
